/**
 * Customer-facing order / fulfillment / pickup schedule labels — never raw enum tokens.
 */
import type { TFunction } from 'i18next';
import { resolvePaymentStatusLabel } from './accountPaymentsPresenter.js';
import type { UnifiedOrderCard } from './unifiedOrdersPresenter.js';

export function resolveFulfillmentStatusLabel(
  t: TFunction<'customer'>,
  status: string,
): string {
  const key = `account.orders.fulfillment.${status}`;
  const label = t(key);
  return label === key ? t('account.orders.statusUnknown') : label;
}

export function resolvePickupScheduleTypeLabel(
  t: TFunction<'customer'>,
  scheduleType: string,
): string {
  const key = `account.orders.pickupSchedule.${scheduleType}`;
  const label = t(key);
  return label === key ? t('account.orders.statusUnknown') : label;
}

/** List card / aria / search — fulfillment row status when present, else payment status. */
export function resolveUnifiedOrderCardStatusLabel(
  t: TFunction<'customer'>,
  card: Pick<UnifiedOrderCard, 'hasFulfillment' | 'orderStatus' | 'paymentStatus' | 'status'>,
): string {
  if (card.hasFulfillment && card.orderStatus !== null) {
    return resolveFulfillmentStatusLabel(t, card.orderStatus);
  }
  if (card.paymentStatus !== null) {
    return resolvePaymentStatusLabel(t, card.paymentStatus);
  }
  return resolveFulfillmentStatusLabel(t, card.status);
}

export function resolvePaymentClaimStatusLabel(
  t: TFunction<'customer'>,
  status: string,
): string {
  const key = `account.paymentClaim.status.${status}`;
  const label = t(key);
  return label === key ? t('account.orders.statusUnknown') : label;
}
